import { Map } from 'immutable';
import actions from './actions';

const initialState = new Map({
  confirmingEmail: false,
  confirmingEmailFailed: null,
  confirmedEmail: false, 
});

export default function confirmEmailReducer(state = initialState, action) {
  switch (action.type) {
    // DO_CONFIRM_EMAIL
    case actions.DO_CONFIRM_EMAIL:
      return state
        .set('confirmingEmail', true)
        .set('confirmedEmail', false)
        .set('confirmingEmailFailed', null)
    case actions.DO_CONFIRM_EMAIL_SUCCEEDED:
      return state
        .set('confirmingEmail', false)
        .set('confirmedEmail', action.payload)
        .set('confirmingEmailFailed', null)
    case actions.DO_CONFIRM_EMAIL_FAILED:
      return state
        .set('confirmingEmail', false)
        .set('confirmedEmail', false)
        .set('confirmingEmailFailed', action.payload)
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/redux/confirm/reducer.js